// src/services/uploadMaintenanceServices.js

import axios from "axios";

const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const apiUrl = `${baseUrl}/api/admin/uploads`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getUploadsOrphansReport = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/orphans`, {
      headers: {
        ...authHeaders(),
      },
    });

    return data;
  } catch (error) {
    console.error("[getUploadsOrphansReport] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const toAbsoluteUploadUrl = (path) => {
  if (!path) return "";

  const value = String(path).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/uploads/")) {
    return `${baseUrl}${value}`;
  }

  return value;
};

export const moveUploadOrphansToTrash = async (paths = []) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/trash`,
      { paths },
      {
        headers: {
          ...authHeaders(),
        },
      },
    );

    return data;
  } catch (error) {
    console.error("[moveUploadOrphansToTrash] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const getUploadsTrashReport = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/trash`, {
      headers: {
        ...authHeaders(),
      },
    });

    return data;
  } catch (error) {
    console.error("[getUploadsTrashReport] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const emptyUploadsTrash = async ({ olderThanDays = 0 } = {}) => {
  try {
    const { data } = await axios.delete(`${apiUrl}/trash`, {
      headers: {
        ...authHeaders(),
      },
      data: {
        olderThanDays,
      },
    });

    return data;
  } catch (error) {
    console.error("[emptyUploadsTrash] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const cleanupEmptyUploadFolders = async () => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/cleanup-empty-folders`,
      {},
      {
        headers: {
          ...authHeaders(),
        },
      },
    );

    return data;
  } catch (error) {
    console.error("[cleanupEmptyUploadFolders] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};
